// MARK://dhk8/pos/i18n/es-MX
// es-MX language pack for the POS shell. Flat key→string map. Components that need
// a string call t('key'). NintaiGO POS is es-MX only for now; this is the seam for
// adding more locales later (the brand pack could carry a `locale` hint).
//
// Convention: keys are `<area>.<thing>` in lowerCamel after the dot. No interpolation
// machinery yet — interpolate at the call site (template strings) until we need ICU.

export const esMX = {
  // generic
  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.close': 'Cerrar',
  'common.search': 'Buscar',
  'common.empty': 'Sin resultados',

  // shell / nav
  'nav.menu': 'Menú',
  'nav.floor': 'Plano',
  'nav.reservations': 'Reservas',
  'nav.waitlist': 'Fila',
  'nav.avisos': 'Avisos',
  'nav.takeout': 'Para llevar',
  'nav.pendingOrders': 'Entrantes',
  'nav.order': 'Comanda',
  'nav.barra': 'Barra',
  'nav.receipt': 'Ticket',
  'nav.tickets': 'Tickets',
  'nav.cashcut': 'Caja',
  'nav.billing': 'Facturas',
  'nav.reports': 'Reportes',
  'nav.manager': 'Manager',
  'nav.printing': 'Impresoras',
  'nav.appearance': 'Apariencia',
  'nav.offline': 'Cola',
  'nav.connection': 'Conexión',
  'nav.diagnostics': 'Diagnóstico',
  'nav.kds': 'Cocina',
  'nav.logout': 'Salir',
  'nav.lock': 'Bloquear terminal',
  'nav.admin': 'Ir al panel de administración',
  // Short label for the icon rail / drawer (the long form above is the tooltip).
  'nav.adminShort': 'Admin',

  // theme toggle
  'theme.toLight': 'Tema claro',
  'theme.toDark': 'Tema oscuro',

  // offline queue
  'offline.title': 'Cola offline',
  'offline.flush': 'Forzar sincronización',
  'offline.flushing': 'Sincronizando…',
  'offline.empty': 'No hay operaciones pendientes.',
  'offline.colKind': 'Operación',
  'offline.colMethod': 'Método',
  'offline.colUrl': 'URL',
  'offline.colAttempts': 'Intentos',
  'offline.colQueuedAt': 'Encolado',
  'offline.remove': 'Cancelar',
  'offline.clear': 'Vaciar cola',
  'offline.confirmClear': '¿Descartar todas las operaciones pendientes? Esta acción no se puede deshacer.',

  // conexión (/offline/cola — connection state + pending-mutations queue)
  'conexion.title': 'Conexión',
  'conexion.subtitle': 'Estado de red y operaciones esperando sincronización.',
  'conexion.status.cloud': 'En línea · nube directa',
  'conexion.status.lan': 'En línea · relay LAN (Pi edge)',
  'conexion.status.offline': 'Sin conexión',
  'conexion.lastSync': 'Última sincronización',
  'conexion.lastSyncNever': 'sin sincronizar aún',
  'conexion.queueTitle': 'Operaciones pendientes',
  'conexion.queueCount.one': '1 operación en cola',
  'conexion.queueCount.other': '{n} operaciones en cola',
  'conexion.empty': 'Todo sincronizado',
  'conexion.emptyHint': 'No hay operaciones esperando para enviarse al servidor.',
  'conexion.retryAll': 'Reintentar todo',
  'conexion.flush': 'Vaciar registro local',
  'conexion.confirmFlush': '¿Vaciar el registro local? Se descartarán todas las operaciones en cola sin enviarlas. Esta acción no se puede deshacer.',
  'conexion.flushed': 'Registro vaciado',
  'conexion.flushedDetail': 'Se descartaron {n} operación(es) de la cola local.',
  'conexion.itemStatus.pendiente': 'Pendiente',
  'conexion.itemStatus.reintentando': 'Reintentando',
  'conexion.itemStatus.error': 'Error',
  'conexion.attempts.one': '1 intento',
  'conexion.attempts.other': '{n} intentos',
  'conexion.kind.comanda': 'Comanda',
  'conexion.kind.pago': 'Pago',
  'conexion.kind.cierre': 'Cierre',
  'conexion.kind.otro': 'Operación',
  'conexion.ageJustNow': 'hace un momento',
  'conexion.ageMin.one': 'hace 1 min',
  'conexion.ageMin.other': 'hace {n} min',
  'conexion.ageHr.one': 'hace 1 h',
  'conexion.ageHr.other': 'hace {n} h',

  // kds
  'kds.title': 'Pantalla de cocina',
  'kds.new': 'Nuevos',
  'kds.queued': 'En espera',
  'kds.inProgress': 'En preparación',
  'kds.ready': 'Listos',
  'kds.empty': 'Sin tickets',
  'kds.stub': 'El servicio dhk8-kds-tickets aún no expone tickets reales — vista de presentación.',
  'kds.allStations': 'Todas las estaciones',
  'kds.station': 'Estación',
  'kds.changeStation': 'Cambiar estación',
  'kds.pickStationTitle': '¿Qué estación es esta pantalla?',
  'kds.pickStationHint': 'Elige la estación de cocina cuyos tickets se mostrarán aquí.',
  'kds.stationIdLabel': 'ID de estación',
  'kds.stationIdPlaceholder': 'p. ej. parrilla, fríos, barra…',
  'kds.useThisStation': 'Usar esta estación',
  'kds.soundOn': 'Silenciar alerta',
  'kds.soundOff': 'Activar alerta',
  'kds.live': 'En vivo',
  'kds.polling': 'Actualización periódica',
  'kds.refresh': 'Refrescar',
  'kds.loadError': 'No se pudieron cargar los tickets',

  // floor
  'floor.title': 'Plano del salón',
  'floor.loadError': 'No se pudo cargar el plano',
  'floor.tableFree': 'Libre',
  'floor.tableOccupied': 'Ocupada',
  'floor.openOrder': 'Abrir comanda',
  'floor.resumeOrder': 'Continuar comanda',

  // menu
  'menu.title': 'Menú',
  'menu.loadError': 'No se pudo cargar el menú',
  'menu.browseHint': 'Toca un producto para ver su detalle',
  // menu — product detail dialog
  'menu.stockOk': 'Disponible',
  'menu.stockLow': 'Pocas unidades',
  'menu.stockOut': 'Agotado',
  'menu.stockUntracked': 'Sin control de inventario',
  'menu.trend': 'Tendencia:',
  'menu.trendUp': 'subiendo',
  'menu.trendFlat': 'estable',
  'menu.trendDown': 'bajando',
  'menu.bestSeller': 'Más vendido',
  'menu.customizable': 'Personalizable',
  'menu.options': 'Variaciones y opciones',
  'menu.optionsHint': 'Se eligen al agregar a la comanda',
  'menu.required': 'Requerido',
  'menu.chooseOne': 'Elige 1',
  'menu.choose': 'Elige',
  'menu.upTo': 'Hasta',

  // caja — cash drawer / shift management
  'caja.title': 'Caja',
  'caja.subtitle': 'Apertura de turno, movimientos de efectivo, arqueo y cortes X / Z.',
  'caja.loadError': 'No se pudo cargar el estado de la caja',
  'caja.closed': 'Caja cerrada',
  'caja.openBadge': 'Caja abierta',
  'caja.openShiftTitle': 'Apertura de turno',
  'caja.openShiftHint': 'Cuenta el fondo inicial por denominación. La suma se calcula sola.',
  'caja.openingFloat': 'Fondo inicial',
  'caja.confirmOpen': 'Abrir turno con',
  'caja.opening': 'Abriendo…',
  'caja.cashierName': 'Cajero / caja',
  'caja.cashierPlaceholder': 'p. ej. María López — Caja 1',
  'caja.shiftInProgress': 'Turno en curso',
  'caja.openedAt': 'Abierto',
  'caja.float': 'Fondo',
  'caja.movements': 'Movimientos de efectivo',
  'caja.movementsHint': 'Registra entradas y salidas de efectivo durante el turno.',
  'caja.cashIn': 'Entrada',
  'caja.cashOut': 'Salida',
  'caja.amount': 'Monto',
  'caja.reason': 'Motivo',
  'caja.reasonPlaceholder': 'p. ej. cambio de la caja fuerte, compra de insumos…',
  'caja.addMove': 'Registrar movimiento',
  'caja.noMoves': 'Sin movimientos registrados.',
  'caja.totalIn': 'Total entradas',
  'caja.totalOut': 'Total salidas',
  'caja.arqueoTitle': 'Arqueo / cierre de turno',
  'caja.arqueoHint': 'Cuenta el efectivo en caja por denominación para cerrar el turno.',
  'caja.counted': 'Efectivo contado',
  'caja.expected': 'Efectivo esperado',
  'caja.expectedFormula': 'Fondo + ventas en efectivo + entradas − salidas',
  'caja.difference': 'Diferencia',
  'caja.balanced': 'Cuadra',
  'caja.over': 'Sobrante',
  'caja.short': 'Faltante',
  'caja.notes': 'Notas',
  'caja.notesRequired': 'Notas (obligatorio si hay diferencia)',
  'caja.notesPlaceholder': 'Justificación de la diferencia, incidentes del turno…',
  'caja.closeShift': 'Cerrar turno (corte Z)',
  'caja.closing': 'Cerrando…',
  'caja.xRead': 'Corte X (lectura)',
  'caja.generateX': 'Generar corte X',
  'caja.reportX': 'Corte X — lectura',
  'caja.reportZ': 'Corte Z — cierre de turno',
  'caja.salesByMethod': 'Ventas por método de pago',
  'caja.tickets': 'Tickets',
  'caja.grossSales': 'Venta bruta',
  'caja.cashReconciliation': 'Conciliación de efectivo',
  'caja.cashSales': 'Ventas en efectivo',
  'caja.printReport': 'Imprimir',
  'caja.closeReport': 'Cerrar',
  'caja.bills': 'Billetes',
  'caja.coins': 'Monedas',
  'caja.qty': 'Cant.',
  'caja.subtotal': 'Subtotal',

  // modo entrenamiento (data sandbox)
  'training.bannerText': 'MODO ENTRENAMIENTO · los cambios no se guardan',
  'training.exit': 'Salir del modo',
  'training.enter': 'Modo entrenamiento',
  'training.enterDesc': 'Practica con datos de prueba sin afectar el turno real. Al salir, los cambios que hagas se descartan.',
  'training.confirmEnter': 'Entrar a modo entrenamiento. Los cambios que hagas aquí no se guardan. ¿Continuar?',

  // entorno test/live ("opción A" estilo Stripe — nivel tenant)
  'env.test': 'Pruebas',
  'env.live': 'Vivo',
  'env.switchToLive': 'vas a cambiar a Vivo',
  'env.switchToTest': 'vas a cambiar a Pruebas',
  'env.confirmLive': 'Vas a operar en modo en vivo — las ventas aquí cuentan. ¿Continuar?',
  'env.accountLoading': 'Cargando la cuenta… el entorno se aplicará en cuanto termine.',
  'env.switcherLabel': 'Entorno',
  'env.bannerText': 'ENTORNO DE PRUEBAS — las ventas aquí no cuentan; cambia a Vivo cuando estés lista',
  'env.switchFailed': 'No se pudo cambiar de entorno',

  // tour guiado (?tour=1)
  'tour.prev': 'Anterior',
  'tour.next': 'Siguiente',
  'tour.finish': 'Listo',
  'tour.skip': 'Saltar',
  'tour.s.floor': 'Esto es el Plano del salón: aquí ves tus mesas y abres una cuenta tocando una.',
  'tour.s.cash': 'Así abres una caja: entra a Caja → Abrir caja y captura el fondo inicial.',
  'tour.s.order': 'Aquí está la Comanda: agregas productos, los mandas a cocina y cobras.',
  'tour.s.kds': 'Cocina / KDS: la pantalla de la cocina con las comandas en preparación.',
  'tour.s.tickets': 'Tickets: el historial de cuentas cerradas y pre-cuentas; desde aquí facturas.',
  'tour.s.menu': 'Menú: explora tus productos, precios y existencias.',
  'tour.s.lock': 'El candado bloquea la terminal — útil cuando te alejas de la caja.',
  'tour.s.golive': 'Cuando estés lista, pasa a Vivo desde el admin (o con este interruptor).',
  // billing / CFDI (P8)
  'billing.title': 'Facturas CFDI',
  'billing.cta': 'Facturar',
  'billing.customers': 'Clientes fiscales',
  'billing.globalDay': 'Factura global del día',
  'billing.facturarTicket': 'Facturar este ticket',
  'billing.uuid': 'Folio fiscal (UUID)',
  'billing.rfcReceptor': 'RFC receptor',
  'billing.razonSocial': 'Razón social',
  'billing.usoCfdi': 'Uso CFDI',
  'billing.regimenFiscal': 'Régimen fiscal',
  'billing.zipCode': 'Código postal',
  'billing.email': 'Email de envío',
  'billing.formaPago': 'Forma de pago',
  'billing.preview': 'Previsualizar',
  'billing.emit': 'Emitir factura',
  'billing.emitting': 'Emitiendo…',
  'billing.emitted': 'Factura emitida',
  'billing.cancelCfdi': 'Cancelar CFDI',
  'billing.cancelMotivo': 'Motivo de cancelación',
  'billing.downloadPdf': 'Descargar PDF',
  'billing.downloadXml': 'Descargar XML',
  'billing.statusVigente': 'Vigente',
  'billing.statusCancelada': 'Cancelada',
  'billing.providerChain': 'Cadena: DocketHub → Omnifiscal → FiscalAPI → SAT',
  'billing.rfcInvalid': 'Revisa el RFC (12–13 caracteres), la razón social y el C.P. (5 dígitos).',

  // errors
  'error.boundaryTitle': 'Algo salió mal',
  'error.boundaryBody': 'La pantalla encontró un error inesperado. Puedes reintentar; si persiste, avisa a soporte.',
} as const

export type I18nKey = keyof typeof esMX

/** Lookup a localized string. Falls back to the key itself if missing (visible in dev). */
export function t(key: I18nKey): string {
  return esMX[key] ?? (key as string)
}
